import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Filter, RestClientList } from '@elderbyte/ngx-starter'
import { environment } from '../../../../../environments/environment'
import { ProductionListScope } from './prod-list-scope'
import { ProductionListConf } from './production-list-conf'

export class ProductionListConfFilter {
  public static readonly SCOPES = 'scopes'

  public static scopes(scopes: ProductionListScope[]): Filter {
    return new Filter(this.SCOPES, scopes)
  }
}

@Injectable({
  providedIn: 'root',
})
export class ProductionListConfService extends RestClientList<ProductionListConf, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const httpClient = inject(HttpClient)
    super(environment.apiPath + '/prod-list-conf', httpClient)
  }
}
